import { useState } from "react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function AdminLoginForm({ onSuccess }) {
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!password) return;
    setBusy(true);
    setError("");
    try {
      const res = await fetch(`${API}/admin/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        setError(typeof data.detail === "string" ? data.detail : "Login failed");
        setBusy(false);
        return;
      }
      onSuccess(data.access_token);
    } catch (err) {
      console.error("admin login failed", err);
      setError("Network error");
      setBusy(false);
    }
  };

  return (
    <form className="tn-admin-login" onSubmit={submit} data-testid="admin-login-form">
      <h3>Admin <span className="accent">//</span> Sign In</h3>
      <p>Enter the admin password to draw coverage routes.</p>
      <input
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        placeholder="Admin password"
        autoFocus
        autoComplete="current-password"
        className="tn-admin-login-input"
        data-testid="admin-password-input"
      />
      {error && <div className="tn-admin-login-error" data-testid="admin-login-error">{error}</div>}
      <button
        type="submit"
        className="tn-btn is-accent"
        disabled={busy}
        data-testid="admin-login-submit"
      >
        {busy ? "Signing in..." : "Sign In →"}
      </button>
    </form>
  );
}
